import { useEffect, useRef } from 'react'
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom'
import './App.css'
import TopBar from './components/TopBar'
import DynamicHeader from './components/headers'
import DynamicFooter from './components/footers'
import FloatingWhatsApp from './components/FloatingWhatsApp'
import HomePage from './pages/HomePage'
import VehicleListings from './pages/VehicleListings'
import VehicleDetail from './pages/VehicleDetail'
import ProposalPage from './pages/ProposalPage'
import { useTenantConfig } from './context/TenantConfigContext'
import { getWhatsAppContact } from './utils/contact'
import { resolveTenantUuid, trackWebsiteView } from './api/tracking'

function SiteLayout() {
  const location = useLocation()
  const isHome = location.pathname === '/'
  const { config } = useTenantConfig()
  const hasWhatsApp = Boolean(getWhatsAppContact(config?.contact))
  const websiteViewSent = useRef(false)

  useEffect(() => {
    if (websiteViewSent.current) return
    const tenantUuid = resolveTenantUuid(config)
    if (!tenantUuid) return
    websiteViewSent.current = true
    trackWebsiteView(tenantUuid)
  }, [config])

  return (
    <div className={`app${isHome ? ' app--home' : ''}${hasWhatsApp ? ' app--whatsapp' : ''}`}>
      <TopBar />
      <DynamicHeader />
      <main>
        <Outlet />
      </main>
      <DynamicFooter />
      <FloatingWhatsApp />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/p/:uuid" element={<ProposalPage />} />
        <Route path="/propuestas/:uuid/:slug" element={<ProposalPage />} />
        <Route path="/propuestas/:uuid" element={<ProposalPage />} />
        <Route path="/proposal/:uuid" element={<ProposalPage />} />
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="vehiculos" element={<VehicleListings />} />
          <Route path="vehiculos/:id" element={<VehicleDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
